var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16669 6.21094L2.50669 0.560935C2.41373 0.467207 2.30313 0.392813 2.18127 0.342044C2.05941 0.291275 1.9287 0.265137 1.79669 0.265137C1.66468 0.265137 1.53397 0.291275 1.41211 0.342044C1.29025 0.392813 1.17965 0.467207 1.08669 0.560935C0.90044 0.748297 0.795898 1.00175 0.795898 1.26593C0.795898 1.53012 0.90044 1.78357 1.08669 1.97094L6.03669 6.97094L1.08669 11.9209C0.90044 12.1083 0.795898 12.3617 0.795898 12.6259C0.795898 12.8901 0.90044 13.1436 1.08669 13.3309C1.17931 13.4254 1.28975 13.5006 1.41163 13.5521C1.5335 13.6036 1.66438 13.6304 1.79669 13.6309C1.929 13.6304 2.05988 13.6036 2.18176 13.5521C2.30363 13.5006 2.41408 13.4254 2.50669 13.3309L8.16669 7.68094C8.2682 7.58729 8.3492 7.47364 8.40461 7.34714C8.46002 7.22064 8.48862 7.08404 8.48862 6.94593C8.48862 6.80783 8.46002 6.67123 8.40461 6.54473C8.3492 6.41823 8.2682 6.30458 8.16669 6.21094Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArrow);
export default __webpack_public_path__ + "static/media/white-arrow.eebf78b2962e899f6e3bd39ad1a722d6.svg";
export { ForwardRef as ReactComponent };